<template>
  <div>
    <h6 class="
        text-prim-grad-1
        fw-bolder
        text-left
        pb-1
        border-bottom border-line-grey
      ">
      Materiale Informativo
    </h6>

    <!-- Sezione Manuali (caricati da utilityService.getManuals is_operatore=true) -->
    <div class="pb-4 mb-4">
  <h4 class="pb-1 mt-1 mb-4">Manuali</h4>
      <b-row v-if="manuals && manuals.length">
        <b-col cols="12" md="6">
          <b-card class="mb-3">
            <h5 class="mb-2">Ultima versione</h5>
            <div v-if="manualItems && manualItems.length">
              <p class="mb-1"><strong>{{ manualItems[0].version || 'Manuale' }}</strong></p>
              <p class="mb-2 text-muted">{{ manualItems[0].description || '' }}</p>
              <div>
                <b-button variant="primary" @click="downloadManual(manualItems[0])" block>
                  {{ manualItems[0].version || 'Scarica manuale' }}
                </b-button>
              </div>
            </div>
            <div v-else>
              <p>Nessun manuale</p>
            </div>
          </b-card>
        </b-col>

        <b-col cols="12" md="6">
          <b-card class="mb-3">
            <h5 class="mb-2">Altre versioni</h5>
            <b-form-select :options="selectOptions" v-model="selectedRelease" class="mb-2" />
            <div>
              <div v-if="selectedGroup && selectedGroup.length">
                <b-button v-if="selectedGroup.length===1" variant="outline-primary" @click="downloadManual(selectedGroup[0])">
                  Scarica selezionato
                </b-button>
                  <div v-else>
                    <div v-for="m in selectedGroup" :key="m.id" class="mb-2">
                      <b-button variant="outline-primary" @click="downloadManual(m)" block>
                        {{ m.version || 'Scarica' }}
                      </b-button>
                    </div>
                  </div>
              </div>
              <b-button v-else :disabled="true" variant="outline-primary">Scarica selezionato</b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- Fallback: mantieni i vecchi link env se l'API non restituisce nulla -->
      <b-row v-else>
        <b-col>
            <h5>
            <a :href="manualeUrl" target="_blank" class="text-primary point" v-if="manualeUrl">
              <u>Scarica versione aggiornata</u>
            </a>
          </h5>
          <h5 v-if="manualeUrlEnglish">
            <a :href="manualeUrlEnglish" target="_blank" class="text-primary point">
              <u>Scarica versione inglese</u>
            </a>
          </h5>
        </b-col>
      </b-row>
    </div>

    <!-- Sezione scaricabili (escludendo i manuali) -->
    <b-row class="flex-column text-left mt-4">
      <b-col v-for="(doc, ind) in downloadable" :key="ind" class="my-3">
        <b-row align-v="center">
          <b-col>
            <h6 class="text-primary">{{ doc.title }}</h6>
            <p class="text-font-light-grey">{{ doc.description }}</p>
          </b-col>
          <b-col>
            <a :href="doc.path" target="_blank" class="btn btn-primary rounded-pills">
              <b-icon icon="download" class="mx-2"></b-icon>
              <span class="mx-2">Scarica</span>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <h6 class="
        text-prim-grad-1
        fw-bolder
        text-left
        pb-1
        border-bottom border-line-grey
      ">
      Videopillole
    </h6>
    <b-row cols="1" cols-md="2" align-v="center" v-for="(vid, ind) in pillole" :key="ind" class="text-left mt-4">
      <b-col>
        <h6 class="text-primary">{{ vid.title }}</h6>
        <p class="text-font-light-grey">{{ vid.description }}</p>
      </b-col>
      <b-col>
        <b-embed type="video" aspect="16by9" controls poster="/assets/dfcontesempre.png">
          <source :src="vid.path" type="video/mp4">
        </b-embed>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { supportService } from "@/_services";
import { utilityService } from "@/_services/utility.service";
import { mapState, mapActions } from "vuex";
export default {
  name: "MaterialeInformativo",
  data() {
    return {
      downloadable: [],
      pillole: [],
      // manuali
      manualeUrl: process.env.VUE_APP_URL_MANUALE_PAZIENTE,
      manualeUrlEnglish: process.env.VUE_APP_URL_MANUALE_PAZIENTE_ENG,
      manuals: [],
      // manualItems: flat array of manual items sorted by order desc
      manualItems: [],
      selectedRelease: null,
    };
  },
  computed: {
    ...mapState({
      alert: (state) => state.alert,
    }),
    // computed per i manuali (flat list)
    latestGroup() {
      if (!this.manualItems || !this.manualItems.length) return [];
      // Assicurati di restituire solo il primo elemento (quello con order più alto)
      return [this.manualItems[0]];
    },
    selectOptions() {
      if (!this.manualItems) return [];
      const others = this.manualItems.slice(1);
      return others.map((m) => ({ 
        value: m.version, 
        text: m.version
      }));
    },
    selectedGroup() {
      if (!this.selectedRelease) return [];
      const found = this.manualItems.find((x) => x.version === this.selectedRelease);
      return found ? [found] : [];
    }
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      errorAlert: "alert/error",
      successAlert: "alert/success",
      infoAlert: "alert/info",
    }),
    fetchData() {
      var self = this;
      // scaricabili: filtriamo i manuali (by title/manuale) perché saranno gestiti separatamente
      supportService
        .getScaricabili()
        .then(function (res) {
          const arr = res?.data?.data || [];
          // escludi elementi che sembrano manuali (title contiene 'Manuale' o path contiene 'manuale')
          self.downloadable = Array.isArray(arr)
            ? arr.filter((d) => {
                const title = (d.title || "").toLowerCase();
                const path = (d.path || "").toLowerCase();
                return !(title.includes("manuale") || path.includes("manuale"));
              })
            : [];
        })
        .catch(function (err) {
          self.errorAlert(
            "Non è stato possibile recuperare i documenti scaricabili"
          );
        });

      supportService
        .getPillole()
        .then(function (res) {
          if (res.data.data[0]) {
            self.pillole = res.data.data[0];
          }
        })
        .catch(function (err) {
          self.errorAlert(
            "Non è stato possibile recuperare i documenti scaricabili"
          );
        });

      // Carica i manuali per operatore usando utilityService
      utilityService
        .getManuals({ is_operatore: true })
        .then((res) => {
          const data = res?.data?.data || [];
          const arr = Array.isArray(data) ? data : [];
          // Sort all items by order desc - la versione con order più alto sarà la prima
          const items = arr.slice().sort((a, b) => (Number(b.order) || 0) - (Number(a.order) || 0));
          self.manualItems = items;
          self.manuals = items; // Anche manuals per il v-if nel template
          console.log('ManualItems debug:', items);
          
          // set default per selectedRelease
          if (!self.selectedRelease && items.length > 1) {
            self.selectedRelease = items[1].version;
          }
        })
        .catch(() => {
          self.manuals = [];
          self.manualGroups = [];
        });
    },
    linkFor(m) {
      if (!m || !m.download_link) return this.manualeUrl || '#';
      try {
        const u = new URL(m.download_link);
        return m.download_link;
      } catch (e) {
        const be = process.env.VUE_APP_BE || '';
        return `${be.replace(/\/$/, '')}/storage/${m.download_link.replace(/^\//, '')}`;
      }
    },
    downloadFilename(m) {
      if (!m || !m.download_link) return '';
      const parts = (m.download_link || '').split('/');
      const original = parts[parts.length - 1] || m.version || 'manuale';
      return `${m.version || original}`;
    },
    downloadManual(m) {
      if (!m) return;
      const url = this.linkFor(m);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener';
      a.download = this.downloadFilename(m) || '';
      document.body.appendChild(a);
      a.click();
      a.remove();
    },
  },
  created() {
    this.fetchData();
  },
};
</script>